<template>
    <transition name="fade">
        <div
            v-if="show"
            @click.self="close"
            class="fixed inset-0 w-full h-screen flex items-center justify-center bg-semi-65 z-40"
        >
            <div
                :class="size"
                class="relative overflow-auto w-full bg-white shadow-lg rounded-lg px-8 py-6 max-h-7/8"
            >
                <button
                    aria-label="close"
                    class="absolute focus:outline-none top-0 right-0 text-xl text-gray-500 my-2 mx-4"
                    @click.prevent="close"
                >×</button>

                <slot />
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        size: {
            type: String,
            default: "max-w-3xl"
        },
        show: {
            required: true,
            type: Boolean
        }
    },
    watch: {
        show(value) {
            if (value) {
                return document
                    .querySelector("body")
                    .classList.add("overflow-hidden");
            }

            document.querySelector("body").classList.remove("overflow-hidden");
        }
    },
    methods: {
        close() {
            this.$emit("close");
        }
    }
};
</script>
